import {
  type CircularProgressProps,
  CircularProgress as HCircularProgress,
  Progress as HProgress,
  type ProgressProps,
} from '@heroui/react';

export const Progress = ({ label, ...rest }: ProgressProps) => {
  return <HProgress {...rest} />;
};

export const CircularProgress = ({ label, ...rest }: CircularProgressProps) => {
  return <HCircularProgress {...rest} />;
};
